import React, { useState, useEffect, useRef } from "react";
import ReactTable from "react-table";
import Pagination from "components/common/Pagination";
import "react-table/react-table.css";
import { withRouter } from "react-router";
import Loader from "../common/Loader";
import Toaster from "../common/Toaster";
import {
  PROVIDER_TYPE,
  SERVICE_REPORT_TYPE,
  TABLE
} from "../../helper/constant";
import EncryptDecrypt from "../../api/EncryptDecrypt";
import moment from "moment-timezone";
import Button from "components/button/Button";
import CommonModel from "../common/CommonModel";
import { DateRangePicker } from "materialui-daterange-picker";
import {
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";
import ClientServices from "../../api/ClientServices";
import FinancialReportServices from "api/FinancialReportServices";
import ProviderReportServices from "api/ProviderReportServices";

const ROLE_SERVICE_ID = {
  4: 1,
  5: 2
};

const FinancialReportViewTable = props => {
  const toaster = useRef(null);

  // Financial Report states
  const [tblData, settblData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pages, setPages] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [field, setField] = useState("created_at");
  const [sortBy, setSortBy] = useState("DESC");
  const [dateRange, setDateRange] = useState({});
  const [modal, setModal] = useState(undefined);
  const [open, setOpen] = useState(false);
  const [RDDropdownOpen, setRDDropdownOpen] = useState(false);
  const [RDId, setRDId] = useState(null);
  const [RDName, setRDName] = useState(null);

  // Provider Specific Report states
  const [providerTblData, setProviderTblData] = useState([]);
  const [providerLoader, setProviderLoader] = useState(false);
  const [providerPages, setProviderPages] = useState(0);
  const [providerActivePage, setProviderActivePage] = useState(0);
  const [providerField, setProviderField] = useState("created_at");
  const [providerSortBy, setProviderSortBy] = useState("DESC");
  const [providerDateRange, setProviderDateRange] = useState({});
  const [providerModal, setProviderModal] = useState(undefined);
  const [providerOpen, setProviderOpen] = useState(false);
  const [providerRDDropdownOpen, setProviderRDDropdownOpen] = useState(false);
  const [providerRDId, setProviderRDId] = useState(null);
  const [providerRDName, setProviderRDName] = useState(null);

  // Common states
  const [RDList, setRDList] = useState([]);
  useEffect(() => {
    if (props.auth && props.auth.admin_role_id !== 3) {
      const params1 = {
        type: "",
        practice_id:
          props.auth && props.auth?.admin_role_id === 6 && props.auth?.practice
            ? props.auth?.practice
            : undefined,
        id:
          props.auth &&
          (props.auth?.admin_role_id === 4 || props.auth?.admin_role_id === 5)
            ? ROLE_SERVICE_ID[props.auth?.admin_role_id]
            : undefined
      };
      ClientServices.RDList(params1).then(result => {
        let data = EncryptDecrypt.decrypt(result.data);
        setRDList(data.data);
      });
    }
    setRDId(
      props.auth && props.auth.admin_role_id !== 3 ? null : props?.auth?.id
    );
    setProviderRDId(
      props.auth && props.auth.admin_role_id !== 3 ? null : props?.auth?.id
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Financial Report useEffect
  useEffect(() => {
    getList(field, sortBy, "", activePage + 1, "");
    setPages(10);
  }, [RDId, dateRange.startDate, dateRange.endDate]);

  // Provider Specific Report useEffect
  useEffect(() => {
    getProviderList(
      providerField,
      providerSortBy,
      "",
      providerActivePage + 1,
      ""
    );
    setProviderPages(10);
  }, [providerRDId, providerDateRange.startDate, providerDateRange.endDate]);

  const toggle = () => {
    setOpen(!open);
    setModal(!open);
  };

  const providerToggle = () => {
    setProviderOpen(!providerOpen);
    setProviderModal(!providerOpen);
  };

  const viewAction = val => {
    props.history.push(`/financial-report/view/${val?.uploaded_csv_id}`);
  };

  async function handleDownload(uploaded_csv_id) {
    const params = {
      uploaded_csv_id: uploaded_csv_id
    };
    try {
      await FinancialReportServices.download(params);
    } catch (error) {
      if (toaster.current) toaster.current.error("Something went wrong!");
    }
  }

  const getColumns = type => {
    return [
      {
        Header: "Uploaded Date",
        accessor: "created_at",
        className: "",
        filterable: false,
        headerClassName: "react-table-header-class sort-sign",
        sortable: true,
        width: 232,
        Cell: ({ value }) =>
          value ? <div>{moment(value).format("MM/DD/YYYY")}</div> : <div>-</div>
      },
      {
        Header: "Uploaded By",
        accessor: type === "finance" ? "uploader_details" : "uploader",
        className: "",
        filterable: false,
        headerClassName: "react-table-header-class sort-sign",
        sortable: true,
        width: 232,
        Cell: ({ value }) =>
          value ? (
            <div>{value?.first_name + " " + value?.last_name}</div>
          ) : (
            <div>-</div>
          )
      },
      {
        Header: "Provider",
        accessor: type === "finance" ? "admin" : "provider",
        className: "",
        filterable: false,
        headerClassName: "react-table-header-class sort-sign",
        sortable: true,
        width: 232,
        Cell: ({ value }) =>
          value ? (
            <div>{value?.first_name + " " + value?.last_name}</div>
          ) : (
            <div>-</div>
          )
      },
      {
        Header: "Service",
        accessor:
          type === "finance"
            ? "admin.rd_detail.service.name"
            : "provider.rd_detail.service.name",
        className: "",
        filterable: false,
        headerClassName: "react-table-header-class sort-sign",
        sortable: true,
        width: 180
      },
      ...(type === "finance"
        ? []
        : [
            {
              Header: "Report Type",
              accessor: "report_type",
              className: "",
              filterable: false,
              headerClassName: "react-table-header-class sort-sign",
              sortable: true,
              width: 280,
              Cell: ({ value }) => {
                return (
                  <div>
                    {value === SERVICE_REPORT_TYPE.ANALYSIS_OF_SERVICES_DETAILS
                      ? "Analysis of Services Details"
                      : "Reimbursement Analysis Details"}
                  </div>
                );
              }
            }
          ]),
      {
        Header: "Action",
        accessor: "action",
        className: "",
        headerClassName: "react-table-header-class",
        sortable: false,
        filterable: false,
        width: 300,
        Cell: props => (
          <div className="react-action-class">
            {type === "finance" ? (
              <Button
                className="c-btn c-info mr-10"
                onClick={() => viewAction(props.original)}
              >
                <div className="fs-14 medium-text" title="View">
                  <i className="fas fa-eye" />
                </div>
              </Button>
            ) : null}

            {type === "finance" ? (
              <Button
                className="c-btn c-info mr-10"
                onClick={() => {
                  if (type === "finance") {
                    handleDownload(
                      // props?.original?.id,
                      props?.original?.uploaded_csv_id
                    );
                  }
                }}
              >
                <div className="fs-14 medium-text" title="Download">
                  <i className="fas fa-download" />
                </div>
              </Button>
            ) : (
              <a
                className="fs-16 medium-text text-decoration-none cursor-pointer whitelight--text"
                title="Download"
                href={`${props?.original?.file_link}`}
              >
                <Button className="c-btn c-info mr-10">
                  <div className="fs-14 medium-text" title="Download">
                    <i className="fas fa-download" />
                  </div>
                </Button>
              </a>
            )}
          </div>
        ) // Custom cell components!
      }
    ];
  };

  const onChangePageGetData = state => {
    if (state.page !== activePage) {
      // alert("on page change you have to call api and get data");
    }
  };

  const SORT_BY_KEYS = {
    "admin.rd_detail.service.name": "service_id",
    uploader_details: "uploader_full_name",
    admin: "admin_full_name",
    created_at: "created_at"
  };

  function getList(field = "", sortBy = "ASC", search = "", page = "1") {
    const params = {
      sort_by: SORT_BY_KEYS[field],
      order: sortBy,
      search: search,
      page: page,
      start_date: dateRange.startDate
        ? moment(dateRange.startDate).format("YYYY-MM-DD")
        : null,
      end_date: dateRange.endDate
        ? moment(dateRange.endDate).format("YYYY-MM-DD")
        : null,
      rd_id:
        props?.auth && props?.auth?.admin_role_id !== 3
          ? RDId
          : props?.auth?.id,
      practice_id:
        props?.auth?.admin_role_id === 6 && props?.auth?.practice
          ? props?.auth?.practice
          : undefined,
      service_id:
        props.auth &&
        (props.auth?.admin_role_id === 4 || props.auth?.admin_role_id === 5)
          ? ROLE_SERVICE_ID[props.auth?.admin_role_id]
          : undefined
    };

    setLoader(true);
    FinancialReportServices.list(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);

        if (data?.status) {
          settblData(data?.data?.rows);
          setPages(Math.ceil(data?.data?.count / TABLE.LIMIT));
        } else {
          if (toaster.current) toaster.current.error(data?.message);
        }
        setLoader(false);
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err?.message);
        setLoader(false);
      });
  }

  function getProviderList(
    field = "",
    sortBy = "ASC",
    search = "",
    page = "1"
  ) {
    const params = {
      sort_by: SORT_BY_KEYS[field],
      order: sortBy,
      search: search,
      page: page,
      start_date: providerDateRange.startDate
        ? moment(providerDateRange.startDate).format("YYYY-MM-DD")
        : null,
      end_date: providerDateRange.endDate
        ? moment(providerDateRange.endDate).format("YYYY-MM-DD")
        : null,
      rd_id:
        props?.auth && props?.auth?.admin_role_id !== 3
          ? providerRDId
          : props?.auth?.id,
      practice_id:
        props?.auth?.admin_role_id === 6 && props?.auth?.practice
          ? props?.auth?.practice
          : undefined,
      service_id:
        props.auth &&
        (props.auth?.admin_role_id === 4 || props.auth?.admin_role_id === 5)
          ? ROLE_SERVICE_ID[props.auth?.admin_role_id]
          : undefined
    };

    setProviderLoader(true);
    // TODO: Update this to call provider-specific API endpoint
    ProviderReportServices.list(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);

        if (data?.status) {
          setProviderTblData(data?.data?.rows);
          setProviderPages(Math.ceil(data?.data?.count / TABLE.LIMIT));
        } else {
          if (toaster.current) toaster.current.error(data?.message);
        }
        setProviderLoader(false);
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err?.message);
        setProviderLoader(false);
      });
  }

  const toggleRD = () => setRDDropdownOpen(prevState => !prevState);
  const toggleProviderRD = () =>
    setProviderRDDropdownOpen(prevState => !prevState);

  return (
    <div>
      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> Financial Reports
            </div>
            {props.auth && props.auth.admin_role_id !== 3 && (
              <>
                <div className="fs-14  mr-10">
                  <Dropdown
                    isOpen={RDDropdownOpen}
                    toggle={toggleRD}
                    disabled={!RDList.length}
                    title="Please select service first!"
                  >
                    <DropdownToggle
                      caret
                      size="md"
                      className={!RDList.length && "cursor-not-allowed"}
                    >
                      {RDName ? RDName : "Providers"}
                    </DropdownToggle>
                    <DropdownMenu
                      modifiers={{
                        setMaxHeight: {
                          enabled: true,
                          order: 890,
                          fn: data => {
                            return {
                              ...data,
                              styles: {
                                ...data.styles,
                                overflow: "auto",
                                maxHeight: "300px"
                              }
                            };
                          }
                        }
                      }}
                    >
                      <DropdownItem
                        key="-1"
                        onClick={() => {
                          setActivePage(0);
                          setRDId("");
                          setRDName("All");
                        }}
                      >
                        All
                      </DropdownItem>
                      {RDList.length > 0 &&
                        RDList.map((result, i) => {
                          return (
                            <DropdownItem
                              key={i + 1}
                              onClick={() => {
                                setActivePage(0);
                                setRDId(result.id);
                                setRDName(
                                  `${result.first_name} ${result.last_name}`
                                );
                              }}
                            >
                              {result.first_name} {result.last_name}{" "}
                              {result?.rd_detail?.type
                                ? `(${PROVIDER_TYPE[result?.rd_detail?.type]})`
                                : "(-)"}
                            </DropdownItem>
                          );
                        })}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </>
            )}
          </div>
          <div className="roe-card-header module-header">
            <div className="d-flex">
              <div className="mr-10">
                <span className="fs-16">Date</span>
                <br></br>
                <Button
                  className="btn btn-secondary btn-md"
                  onClick={() => toggle()}
                >
                  {dateRange.startDate
                    ? `${moment(dateRange.startDate).format(
                        "MM/DD/YYYY"
                      )} - ${moment(dateRange.endDate).format("MM/DD/YYYY")}`
                    : "Select Date"}
                </Button>
                {dateRange && dateRange.startDate && (
                  <Button
                    className="btn btn-secondary btn-md ml-2"
                    onClick={() => {
                      setActivePage(0);
                      setDateRange({});
                    }}
                  >
                    Reset date
                  </Button>
                )}
              </div>
            </div>
          </div>
          <div className="roe-card-body">
            <ReactTable
              style={{
                border: "none",
                boxShadow: "none"
              }}
              data={tblData}
              columns={getColumns("finance")}
              defaultPageSize={10}
              minRows={2}
              manual
              defaultFilterMethod={(filter, row) => {
                const id = filter.pivotId || filter.id;

                return row[id] !== undefined
                  ? String(row[id].toLowerCase()).includes(
                      filter.value.toLowerCase()
                    )
                  : true;
              }}
              className="-striped -highlight custom-react-table-theme-class"
              pages={pages}
              page={activePage}
              PaginationComponent={Pagination}
              loading={loader}
              LoadingComponent={Loader}
              onFetchData={onChangePageGetData}
              onPageChange={pageIndex => {
                setActivePage(pageIndex);
                getList(field, sortBy, "", pageIndex + 1, "");
              }}
              onSortedChange={sortProperties => {
                const sort = sortProperties[0].desc ? "DESC" : "ASC";
                setSortBy(sort);
                setActivePage(0);
                setField(sortProperties[0].id);
                getList(sortProperties[0].id, sort, "", 1, "");
                // alert("sort handler", sortProperties);
                // const orderByDirection = sortProperties[0].desc ? 1 : 0;

                // updateMapStateInfoOrderByColumn(sortProperties[0].id, orderByDirection);
              }}
            />
          </div>
          <CommonModel
            modal={modal}
            toggle={toggle}
            size="lg"
            children={
              <DateRangePicker
                open={open}
                toggle={() => toggle()}
                value={[dateRange.startDate, dateRange.endDate]}
                onChange={range => {
                  setActivePage(0);
                  setDateRange(range);
                  // setModal(!modal)
                  toggle();
                }}
                closeOnClickOutside={true}
              />
            }
            // header={editedData ? "" : "Add Registration Code"}
          />
        </div>
      </div>
      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> Provider Specific Reports
            </div>
            {props.auth && props.auth.admin_role_id !== 3 && (
              <>
                <div className="fs-14  mr-10">
                  <Dropdown
                    isOpen={providerRDDropdownOpen}
                    toggle={toggleProviderRD}
                    disabled={!RDList.length}
                    title="Please select service first!"
                  >
                    <DropdownToggle
                      caret
                      size="md"
                      className={!RDList.length && "cursor-not-allowed"}
                    >
                      {providerRDName ? providerRDName : "Providers"}
                    </DropdownToggle>
                    <DropdownMenu
                      modifiers={{
                        setMaxHeight: {
                          enabled: true,
                          order: 890,
                          fn: data => {
                            return {
                              ...data,
                              styles: {
                                ...data.styles,
                                overflow: "auto",
                                maxHeight: "300px"
                              }
                            };
                          }
                        }
                      }}
                    >
                      <DropdownItem
                        key="-1"
                        onClick={() => {
                          setProviderActivePage(0);
                          setProviderRDId("");
                          setProviderRDName("All");
                        }}
                      >
                        All
                      </DropdownItem>
                      {RDList.length > 0 &&
                        RDList.map((result, i) => {
                          return (
                            <DropdownItem
                              key={i + 1}
                              onClick={() => {
                                setProviderActivePage(0);
                                setProviderRDId(result.id);
                                setProviderRDName(
                                  `${result.first_name} ${result.last_name}`
                                );
                              }}
                            >
                              {result.first_name} {result.last_name}{" "}
                              {result?.rd_detail?.type
                                ? `(${PROVIDER_TYPE[result?.rd_detail?.type]})`
                                : "(-)"}
                            </DropdownItem>
                          );
                        })}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </>
            )}
          </div>
          <div className="roe-card-header module-header">
            <div className="d-flex">
              <div className="mr-10">
                <span className="fs-16">Date</span>
                <br></br>
                <Button
                  className="btn btn-secondary btn-md"
                  onClick={() => providerToggle()}
                >
                  {providerDateRange.startDate
                    ? `${moment(providerDateRange.startDate).format(
                        "MM/DD/YYYY"
                      )} - ${moment(providerDateRange.endDate).format(
                        "MM/DD/YYYY"
                      )}`
                    : "Select Date"}
                </Button>
                {providerDateRange && providerDateRange.startDate && (
                  <Button
                    className="btn btn-secondary btn-md ml-2"
                    onClick={() => {
                      setProviderActivePage(0);
                      setProviderDateRange({});
                    }}
                  >
                    Reset date
                  </Button>
                )}
              </div>
            </div>
          </div>
          <div className="roe-card-body">
            <ReactTable
              style={{
                border: "none",
                boxShadow: "none"
              }}
              data={providerTblData}
              columns={getColumns("provider")}
              defaultPageSize={10}
              minRows={2}
              manual
              defaultFilterMethod={(filter, row) => {
                const id = filter.pivotId || filter.id;

                return row[id] !== undefined
                  ? String(row[id].toLowerCase()).includes(
                      filter.value.toLowerCase()
                    )
                  : true;
              }}
              className="-striped -highlight custom-react-table-theme-class"
              pages={providerPages}
              page={providerActivePage}
              PaginationComponent={Pagination}
              loading={providerLoader}
              LoadingComponent={Loader}
              onFetchData={onChangePageGetData}
              onPageChange={pageIndex => {
                setProviderActivePage(pageIndex);
                getProviderList(
                  providerField,
                  providerSortBy,
                  "",
                  pageIndex + 1,
                  ""
                );
              }}
              onSortedChange={sortProperties => {
                const sort = sortProperties[0].desc ? "DESC" : "ASC";
                setProviderSortBy(sort);
                setProviderActivePage(0);
                setProviderField(sortProperties[0].id);
                getProviderList(sortProperties[0].id, sort, "", 1, "");
              }}
            />
          </div>
          <CommonModel
            modal={providerModal}
            toggle={providerToggle}
            size="lg"
            children={
              <DateRangePicker
                open={providerOpen}
                toggle={() => providerToggle()}
                value={[providerDateRange.startDate, providerDateRange.endDate]}
                onChange={range => {
                  setProviderActivePage(0);
                  setProviderDateRange(range);
                  providerToggle();
                }}
                closeOnClickOutside={true}
              />
            }
          />
        </div>
      </div>
      <Toaster ref={toaster} />
    </div>
  );
};

export default withRouter(FinancialReportViewTable);
